import type {
	PreferencesModel,
	UserModel,
	UsersModel,
} from '@/shared/generated'
import type { UseQueryOptions } from '@/shared/lib/query-client'

import { useQuery } from '@tanstack/react-query'
import { any, prop, propOr, uniqBy } from 'lodash/fp'

import { client } from '@/shared/api/client'

export const userQueries = {
	preferences: () => ({
		queryKey: ['preferences'],
		queryFn: () => client.users.getCurrentUserPreferences(),
	}),
	me: () => ({
		queryKey: ['me'],
		queryFn: () => client.users.getCurrentUser(),
	}),
	users: () => ({
		queryKey: ['users'],
		queryFn: () => client.users.getUsers(),
	}),
}
export const usePreferencesQuery = <T = PreferencesModel>(
	options?: UseQueryOptions<PreferencesModel, Error, T>
) =>
	useQuery<PreferencesModel, Error, T>({
		...userQueries.preferences(),
		...(options || {}),
	})

export const useUsersQuery = <T = UsersModel>(
	options?: UseQueryOptions<UsersModel, Error, T>
) =>
	useQuery<UsersModel, Error, T>({
		...userQueries.users(),
		...(options || {}),
	})

export const useAllUsersQuery = () => {
	const users = useUsersQuery()
	const me = useCurrentUserQuery()
	const data: UserModel[] = uniqBy(
		'id',
		[...propOr([], 'data.users', users), me.data].filter(Boolean)
	)

	return {
		...users,
		isLoading: any(prop('isLoading'), [users, me]),
		data,
	}
}

export const useCurrentUserQuery = <T = UserModel>(
	options?: UseQueryOptions<UserModel, Error, T>
) =>
	useQuery<UserModel, Error, T>({
		...userQueries.me(),
		retry: false,
		...(options || {}),
	})
